// @ts-nocheck converted from existing component
// If making changes look to fix and remove this

import React from "react"
import Notification from "../Notification"
import { useContentJsx } from "@/utils/hooks/useContent"
import { useSelector } from "react-redux"
import { selectMemberDetails } from "@/store/apis/linkApi"

function TaxFileNumberMissing() {
  const { tfnProvided } = useSelector(selectMemberDetails)
  const { contentBody: content } = useContentJsx(
    `dashboard_notifications.tax_file_number_missing`
  )

  if (tfnProvided) {
    return null
  }

  return (
    <Notification notificationType={"bell-alert"} closeButton={true}>
      {content}
    </Notification>
  )
}

export default TaxFileNumberMissing
